import { GridRenderEditCellParams, GridRowModes } from '@mui/x-data-grid-pro';
import React, { ChangeEvent, FC } from 'react';
import Checkbox from '@mui/material/Checkbox';
import { renderBooleanCell } from './common';

interface IGridColConditionProps {
  params: GridRenderEditCellParams;
  disabled?: boolean,
  onChange?(event: ChangeEvent<HTMLInputElement>, checked: boolean): void;
}

export const GridColBoolean: FC<IGridColConditionProps> = ({ params, disabled, onChange }) => {
  const { api, id, field, value } = params;

  const isEditMode = api.getRowMode(id) === GridRowModes.Edit;

  const handleChange = (event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
    api.setEditCellValue({ id, field, value: checked });
    onChange?.(event, checked);
  };

  return isEditMode ? (
    <Checkbox checked={!!value} value={String(value)} disabled={disabled} onChange={handleChange} />
  ) : (
    <span>{renderBooleanCell(params)}</span>
  );
};
